const { adminCall } = require("./_utils");

module.exports = {
  draft: data => adminCall("licence.draft", data),
  create: data => adminCall("licence.create", data),
  modify: data => adminCall("licence.modify", data),
  remove: uid => adminCall("licence.remove", { uid }),
  getAppMeta: uid => adminCall("licence.getAppMeta", { uid }),
  generateApiToken: data => adminCall("licence.generateApiToken", data)
}
